import styled from "styled-components";
import { fadeInUp } from "react-animations";

export const MainContainer = styled.div`
  float: left;
  width: 69%;
  margin-top: 2%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const TitleFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 30px;
  @media screen and (max-width: 768px) {
    align-items: center;
    width: 100%;
  }
`;

export const BackArrowContainer = styled.div`
  margin-top: 20px;
  @media screen and (max-width: 768px) {
    margin-left: 0px;
    margin-top: 15px;
  }
`;

export const TitleForm = styled.h2`
  font-family: "Lovelo Black", "Segoe UI";
  font-size: 2.438vw;
  white-space: pre-line;
  font-weight: 900;

  @media screen and (max-width: 768px) {
    font-size: 34px;
  }
`;

export const FormDescription = styled.h3`
  margin: 0px;
  font-family: Roboto;
  font-size: 1.875vw;
  white-space: pre-line;
  @media screen and (max-width: 768px) {
    font-size: 25px;
  }
`;

export const TitleSection = styled.h3`
  font-family: Roboto;
  font-size: 1.563vw;
  white-space: pre-line;
  margin-left: 6.25vw;
  @media screen and (max-width: 768px) {
    margin-left: 10px;
    font-size: 25px;
  }
`;

export const SectionContainer3Columns = styled.div`
  margin-left: 6.25vw;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 1.875vw;
  column-gap: 1.875vw;
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-left: 10px;
    margin-right: 10px;
    column-gap: 0px;
    row-gap: 25px;
  }
`;

export const SectionContainer2Columns = styled.div`
  margin-left: 6.25vw;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 1.875vw;
  column-gap: 1.875vw;
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const SectionContainer1Column = styled.div`
  margin-left: 6.25vw;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 1.875vw;
  column-gap: 1.875vw;
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const ActivePasiveText = styled.h3`
  font-family: Roboto;
  font-size: 1.25vw;
  white-space: pre-line;
  margin-top: 0;
  margin-left: 6.25vw;
  @media screen and (max-width: 768px) {
    margin-left: 0px;
    font-size: 20px;
  }
`;

export const SnackbarContainer = styled.div`
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

export const CuentasContainer = styled.div`
  margin-left: 6.25vw;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-left: 10px;
    margin-right: 10px;
    column-gap: 0px;
    row-gap: 25px;
  }
`;
